import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const LOGO_URL = "/gostreet-logo.png";
export const LOGO_DARK_URL = "/gostreet-logo-dark.png";

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  // Prefer consultant/admin token; fall back to client (PWA) token
  const token = localStorage.getItem("gs_token") || localStorage.getItem("gs_client_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem("gs_token");
      // Don't auto-redirect — let components decide
    }
    return Promise.reject(err);
  }
);

export default api;

export const fileUrl = (path) => `${API}/files/${path}`;

export const STATUS_LABEL = {
  nuova: "Nuova",
  presa_in_carico: "Presa in carico",
  in_lavorazione: "In lavorazione",
  chiusa: "Chiusa",
};
